export default __webpack_public_path__ + "static/media/dislikeBlack.4013eb1b.svg";